// extracted by mini-css-extract-plugin
export var orderDetails = "_rj-2";
export var orderImage = "_rj-1";
export var orderMeta = "_rj-3";
export var orderSummary = "_rj-0";
export var rightArrow = "_rj-4";